/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { CarrierBasicProperties } from "./CarrierBasicProperties";
import {
  CarrierBasicPropertiesFromJSON,
  CarrierBasicPropertiesFromJSONTyped,
  CarrierBasicPropertiesToJSON,
  CarrierBasicPropertiesToJSONTyped,
} from "./CarrierBasicProperties";
import type { CarrierPaymentProperties } from "./CarrierPaymentProperties";
import {
  CarrierPaymentPropertiesFromJSON,
  CarrierPaymentPropertiesFromJSONTyped,
  CarrierPaymentPropertiesToJSON,
  CarrierPaymentPropertiesToJSONTyped,
} from "./CarrierPaymentProperties";
import type { CarrierContactInfo } from "./CarrierContactInfo";
import {
  CarrierContactInfoFromJSON,
  CarrierContactInfoFromJSONTyped,
  CarrierContactInfoToJSON,
  CarrierContactInfoToJSONTyped,
} from "./CarrierContactInfo";
import type { CarrierInfoResponseService } from "./CarrierInfoResponseService";
import {
  CarrierInfoResponseServiceFromJSON,
  CarrierInfoResponseServiceFromJSONTyped,
  CarrierInfoResponseServiceToJSON,
  CarrierInfoResponseServiceToJSONTyped,
} from "./CarrierInfoResponseService";

/**
 *
 * @export
 * @interface CarrierInfoResponse
 */
export interface CarrierInfoResponse {
  /**
   *
   * @type {CarrierBasicProperties}
   * @memberof CarrierInfoResponse
   */
  carrierBasicProperties: CarrierBasicProperties;
  /**
   *
   * @type {CarrierPaymentProperties}
   * @memberof CarrierInfoResponse
   */
  carrierPaymentStrategy: CarrierPaymentProperties;
  /**
   *
   * @type {Array<CarrierInfoResponseService>}
   * @memberof CarrierInfoResponse
   */
  services: Array<CarrierInfoResponseService>;
  /**
   *
   * @type {CarrierContactInfo}
   * @memberof CarrierInfoResponse
   */
  contactInfo: CarrierContactInfo;
}

/**
 * Check if a given object implements the CarrierInfoResponse interface.
 */
export function instanceOfCarrierInfoResponse(
  value: object,
): value is CarrierInfoResponse {
  if (
    !("carrierBasicProperties" in value) ||
    value["carrierBasicProperties"] === undefined
  )
    return false;
  if (
    !("carrierPaymentStrategy" in value) ||
    value["carrierPaymentStrategy"] === undefined
  )
    return false;
  if (!("services" in value) || value["services"] === undefined) return false;
  if (!("contactInfo" in value) || value["contactInfo"] === undefined)
    return false;
  return true;
}

export function CarrierInfoResponseFromJSON(json: any): CarrierInfoResponse {
  return CarrierInfoResponseFromJSONTyped(json, false);
}

export function CarrierInfoResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CarrierInfoResponse {
  if (json == null) {
    return json;
  }
  return {
    carrierBasicProperties: CarrierBasicPropertiesFromJSON(
      json["carrierBasicProperties"],
    ),
    carrierPaymentStrategy: CarrierPaymentPropertiesFromJSON(
      json["carrierPaymentStrategy"],
    ),
    services: (json["services"] as Array<any>).map(
      CarrierInfoResponseServiceFromJSON,
    ),
    contactInfo: CarrierContactInfoFromJSON(json["contactInfo"]),
  };
}

export function CarrierInfoResponseToJSON(json: any): CarrierInfoResponse {
  return CarrierInfoResponseToJSONTyped(json, false);
}

export function CarrierInfoResponseToJSONTyped(
  value?: CarrierInfoResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    carrierBasicProperties: CarrierBasicPropertiesToJSON(
      value["carrierBasicProperties"],
    ),
    carrierPaymentStrategy: CarrierPaymentPropertiesToJSON(
      value["carrierPaymentStrategy"],
    ),
    services: (value["services"] as Array<any>).map(
      CarrierInfoResponseServiceToJSON,
    ),
    contactInfo: CarrierContactInfoToJSON(value["contactInfo"]),
  };
}
